module.exports = __webpack_public_path__ + "static/media/profile_marcel.cdabe7ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/profile_marcel.png
// module id = 1122
// module chunks = 4